var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PipeUpdateRequest_1;
/* eslint-disable import/no-duplicates */
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './challengeData';
import { pipeUpdateRequestSchemaValidation } from '../validations.generated';
const NAME_MAX_LENGTH = 100;
export const pipeUpdateRequestSchema = {
    $id: 'urn:wisepipe-base-pipe:PipeUpdateRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        name: { type: 'string', minLength: 1, maxLength: NAME_MAX_LENGTH },
        image: { type: 'string', maxLength: 1024 },
        parentFolderID: {
            oneOf: [
                { type: 'string', uid: 9 },
                { type: 'string', minLength: 0, maxLength: 0 } // empty string to remove the attribute
            ]
        },
        challengeData: { $ref: 'urn:wisepipe-base-pipe:ChallengeData' },
        rowVersion: { type: 'number', minimum: 0 }
    },
    required: ['pipeID'],
    // rowVersion is required for updating parentFolderID or challengeData, but not for updating name or image
    if: { anyOf: [{ required: ['parentFolderID'] }, { required: ['challengeData'] }] },
    then: { required: ['rowVersion'] }
};
let PipeUpdateRequest = PipeUpdateRequest_1 = class PipeUpdateRequest {
    constructor(pipeID, name, image, parentFolderID, challengeData, rowVersion) {
        this.pipeID = pipeID;
        if (name !== undefined)
            this.name = name;
        if (image !== undefined)
            this.image = image;
        if (parentFolderID !== undefined)
            this.parentFolderID = parentFolderID;
        if (challengeData !== undefined)
            this.challengeData = challengeData;
        if (rowVersion !== undefined)
            this.rowVersion = rowVersion;
        JSON.validate(this, PipeUpdateRequest_1);
    }
};
PipeUpdateRequest.NAME_MAX_LENGTH = NAME_MAX_LENGTH;
PipeUpdateRequest = PipeUpdateRequest_1 = __decorate([
    JsonSchemaV2(pipeUpdateRequestSchema, pipeUpdateRequestSchemaValidation)
], PipeUpdateRequest);
export { PipeUpdateRequest };
//# sourceMappingURL=pipeUpdateRequest.js.map